import Breadcrumbs from 'app/shared-components/marketing/Breadcrumbs';
import ArticleViewContent from 'app/shared-components/article/ArticleViewContent';
import ArticleHeaderTags from 'app/shared-components/helmet/ArticleHeaderTags';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useEffect } from 'react';
import {fetchArticle, selectArticleById} from "app/store/articlesSlice";

export default function ArticlePreviewPage() {
  const routeParams = useParams();
  const dispatch = useDispatch();
  const article = useSelector(selectArticleById(routeParams.id));

  useEffect(() => {
    if (!article) {
      dispatch(fetchArticle(routeParams.id));
    }
  }, [dispatch, routeParams.id, article]);

  return (
    <>
    {article && (
      <ArticleHeaderTags 
        title={article.title} 
        description={article.excerpt || article.title} 
        userAuthor={article.userAuthor}
        organizationAuthor={article.organizationAuthor}
        datePublished={article.createdAt} 
        image={article.headerImageUrl}
      />
    )}
    <div>
      {/* Breadcrumbs */}
      <section>
        <div className="container py-28">
          <Breadcrumbs
            trail={[
              { label: 'Home', to: '/' },
              { label: 'Articles', to: '/articles' },
              ...(article ? [{ label: article.title, to: `/article/${article.id}` }] : [])
            ]}
          />
        </div>
      </section>

      {/* Article content */}
      <section>
        <div className="container pb-20 lg:pb-80">
          <ArticleViewContent article={article} mode="public" />
        </div>
      </section>
    </div>
    </>
  )
}